// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  alertsPageNumber: 1,
  alertsLimitPage: 10,
  filterData: {},
  alertRuleConditions: undefined,
  alertRuleStatuses: undefined,
  alertRuleStores: undefined,
  alertRulePageNumber: 1,
  alertRuleLimitPage: 10
}
